import axios, { AxiosError } from 'axios';
import { format } from 'date-fns';

import { addQueryParams, handleResponseError } from '../service';
import { ResponseTO } from '../../types/response-to.type';
import { PetitionsReport } from '../../types/petitions-report.type';
import { DateRange } from '../../types/date-range.type';

const BASE_URL = process.env.REACT_APP_BI_URL;

const downloadExcel = async (range: DateRange, token: string) => {
    try {
        const from = format(range.from!, 'yyyy-MM-dd');
        const to = format(range.to!, 'yyyy-MM-dd');
        const queryParams = addQueryParams({ from, to });
        const response = await axios.get(
            `${BASE_URL}/petitions/excel${queryParams}`,
            {
                headers: { Authorization: `Bearer ${token}` },
                responseType: 'blob',
            }
        );
        return response.data;
    } catch (err) {
        console.error('Error downloading users excel:', err);
        return undefined;
    }
};

const getReport = async (
    token: string,
    params?: Record<string, string>
): Promise<ResponseTO<PetitionsReport>> => {
    try {
        const queryParams = addQueryParams(params);
        const response = await axios.get(
            `${BASE_URL}/petitions/general-report${queryParams}`,
            {
                headers: { Authorization: `Bearer ${token}` },
            }
        );
        return response.data;
    } catch (err) {
        return handleResponseError(err as AxiosError);
    }
};

export { downloadExcel, getReport };
